import * as React from 'react';
import { Link, type LinkProps } from '@tanstack/react-router';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface BaseProps {
  label: string;
  value: string;
  hint?: string;
  className?: string;
}

interface DivProps extends BaseProps {
  to?: undefined;
}

interface LinkVariantProps extends BaseProps {
  to: LinkProps['to'];
  search?: LinkProps['search'];
}

export function KpiCard(props: DivProps | LinkVariantProps) {
  const inner = (
    <Card className={cn('p-0', 'to' in props && props.to ? 'transition-colors hover:border-primary/40 hover:bg-muted/40' : null, props.className)}>
      <CardContent className="space-y-1 p-4">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">{props.label}</p>
        <p className="text-2xl font-semibold leading-tight">{props.value}</p>
        {props.hint && <p className="text-xs text-muted-foreground">{props.hint}</p>}
      </CardContent>
    </Card>
  );
  if ('to' in props && props.to) {
    return (
      <Link to={props.to} search={props.search} className="block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg">
        {inner}
      </Link>
    );
  }
  return inner;
}
